<template>
  <v-container class="fill-height d-flex flex-column justify-center align-center">
    <v-icon size="100" color="amv-yellow" class="mb-4">mdi-lock-outline</v-icon>
    <h1 class="text-h4 mb-2">Premium Feature</h1>
    <p class="text-body-1 text-center mb-6" style="max-width: 400px;">
      This <strong>report</strong> is only available for customers on our Premium plan. 
      Would you like to unlock this for your team?
    </p>
    <v-btn color="amv-blue" size="large" to="/dashboard">Back to Dashboard</v-btn>
    <v-btn variant="text" class="mt-4" href="mailto:sales@amv.no">Contact Sales</v-btn>
  </v-container>
</template>